import React from 'react';
import Box from '@mui/material/Box';
import CapsoIcon from './UI/CapsoIcon';
import Paper from '@mui/material/Paper';
import {statusDesc} from '@capsovision/capso_utils';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import StatusSequence from './StatusSequence';
import { DownloadPDF } from './FileDownloader';
import Typography from '@mui/material/Typography';
import CountdownTimer from './UI/CountdownTimer';
import MuiLink from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';

const CurStatus = ({curProcedure}) => {

	const curStatus = curProcedure.status;
	const isInTransit = curStatus.toLowerCase() === 'in transit';
	const procedureCanceled = curStatus === 'procedure canceled';

	return (
		<React.Fragment>
			<Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
				{
					!procedureCanceled && curStatus !== 'report signed' &&
					<CountdownTimer 
						targetDate={curProcedure.ingestionTime ? curProcedure.ingestionTime : moment(curProcedure.procedureDate).add(1, 'hour')}	// If the ingestion time is missing, replace it with procedure date + 1 hour
						countUp={true} 
						fontSize={3}
					/>
				}
			</Box>
			<Box sx={{ mt: 3 }}>
				<Box>
					<Paper variant="outlined" sx={{ p: 3, mb: 3, borderColor: 'primary.main' }}>
						<Typography variant="h6" color="primary" align="center">
							{ procedureCanceled ? `The ingestion was unsuccessful, and your procedure has been canceled. Please follow up with your physician for further guidance. (SN: ${curProcedure.sn})` : statusDesc[curStatus] }
						</Typography>
					</Paper>
				</Box>
				<Box sx={{ display: 'flex', justifyContent: 'center' }}>
					<CapsoIcon iconName={`status-${curStatus.split(' ').join('')}`} size="xl" />
				</Box>
				
				{isInTransit && curProcedure.trackingUrl && (
					<Box sx={{ textAlign: 'center', mt: 2, mb: 2 }}>
						<Typography variant="body1">
							Click <MuiLink href={curProcedure.trackingUrl} target="_blank" rel="noopener">here</MuiLink> to track your capsule
						</Typography>
					</Box>
				)}
				
				<Stack direction="row" spacing={2} sx={{ mt: 2, justifyContent: 'center' }}>
					{ curProcedure.videoReady &&
					<Tooltip title="View Video">
						<Button 
							variant="outlined" 
							component={RouterLink} 
							to={`/video/${curProcedure.id}`}
						>
							<CapsoIcon iconName="action-videostream" size="md" />
						</Button>
					</Tooltip>
					}
					{ curProcedure.reportReady &&
					<Tooltip title="Download Report">
						<Button variant="outlined" onClick={() => DownloadPDF(curProcedure.id)}>
							<CapsoIcon iconName="action-downloadpdf" size="md" />
						</Button>
					</Tooltip>
					}
				</Stack>
			</Box>
			{
				!procedureCanceled && <StatusSequence curStatus={curStatus} />
			}
		</React.Fragment>
	)
}

export default CurStatus;